export default function Testimonials() {
  const testimonials = [
    {
      name: 'Marcus Thompson',
      role: 'Fitness Coach',
      rating: 5,
      text: 'Best barbershop in town! The attention to detail is incredible. Mr. C always knows exactly what I need and delivers perfection every time. The atmosphere is professional yet relaxing.',
      image: 'https://public.readdy.ai/ai/img_res/5974ffb6c56574ded8150798f3516c9e.jpg'
    },
    {
      name: 'David Kim',
      role: 'Graphic Designer',
      rating: 5,
      text: 'I have been coming here for over 3 years and would not go anywhere else. The quality of service is consistently outstanding. Mr. C is a master at modern fades and always exceeds my expectations.',
      image: 'https://readdy.ai/api/search-image?query=Asian%20male%20portrait%2C%20creative%20designer%20wearing%20casual%20t-shirt%20and%20denim%20jacket%2C%20glasses%2C%20clean%20simple%20background%2C%20trendy%20hairstyle%2C%20artistic%20and%20friendly%20appearance%2C%20natural%20expression&width=200&height=200&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Carlos Rodriguez',
      role: 'Restaurant Owner',
      rating: 5,
      text: 'The hot towel shave experience is absolutely luxurious. Mr. C is incredibly skilled with beard grooming. This place sets the standard for what a premium barbershop should be.',
      image: 'https://readdy.ai/api/search-image?query=Hispanic%20Latino%20male%20portrait%2C%20well-groomed%20beard%2C%20wearing%20casual%20button-up%20shirt%2C%20clean%20simple%20background%2C%20warm%20smile%2C%20confident%20and%20friendly%2C%20modern%20style&width=200&height=200&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Jamal Washington',
      role: 'Music Producer',
      rating: 5,
      text: 'Outstanding service from start to finish. Mr. C really listens to what you want and delivers exceptional results. The ambiance is perfect and the attention to detail is unmatched.',
      image: 'https://readdy.ai/api/search-image?query=Black%20male%20portrait%2C%20stylish%20appearance%20wearing%20streetwear%20hoodie%20and%20chain%20necklace%2C%20clean%20simple%20background%2C%20fresh%20haircut%20and%20beard%2C%20confident%20creative%20personality%2C%20urban%20style&width=200&height=200&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Ahmed Hassan',
      role: 'Small Business Owner',
      rating: 5,
      text: 'Professional, skilled, and always on time. I appreciate the consistency and quality. Mr. C does an amazing job with hair coloring. This is the only place I trust for my grooming needs.',
      image: 'https://readdy.ai/api/search-image?query=Middle%20Eastern%20male%20portrait%2C%20wearing%20casual%20polo%20shirt%2C%20clean%20simple%20background%2C%20well-groomed%20appearance%2C%20friendly%20smile%2C%20approachable%20and%20professional%2C%20natural%20lighting&width=200&height=200&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'Tyler Chen',
      role: 'College Student',
      rating: 5,
      text: 'The best investment in my appearance. Every visit is a great experience. Mr. C is a true professional who takes pride in his work. Highly recommend to anyone looking for quality.',
      image: 'https://readdy.ai/api/search-image?query=Young%20Asian%20male%20portrait%2C%20college%20student%20wearing%20casual%20hoodie%20and%20backpack%20strap%2C%20clean%20simple%20background%2C%20modern%20hairstyle%2C%20friendly%20and%20relaxed%2C%20youthful%20appearance&width=200&height=200&seq=testimonial-006&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from our satisfied clients about their experiences
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h3 className="text-lg font-bold text-black">{testimonial.name}</h3>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-xl w-6 h-6 flex items-center justify-center"></i>
                ))}
              </div>

              <p className="text-gray-600 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
